export enum REQUIREMENTS_TYPES {
  NFT = "NFT",
  TOKEN = "TOKEN",
  WHITELIST = "WHITELIST",
  WHITELIST_FREE_MINT = "WHITELIST_FREE_MINT",
}
